export default {"src":"/_next/static/media/uhc-logo.7256b180.svg","height":22,"width":105,"blurWidth":0,"blurHeight":0};